/**
* Adds a Confused.LookupServiceProxy class to the Confused namespace. 
* Implemented as IIFE so we can pass in references to the global jQuery and document objects.
**/
(function($, w) {

    w.Confused = w.Confused || {};

    /**
    * Helper for utilising the lookup service
    *
    * @constructor
    * @param {object} [endpoint] the endpoint that returns the label, [timeout=500] time (in ms) before making AJAX request, 
    */
    w.Confused.LookupServiceProxy = function(options) {

        var defaults = { endpoint: "Services/Lookup/LookupService.aspx", timeout: 300 };

        var settings = $.extend(true, defaults, options);

        this.serviceProxy = new w.Confused.ServiceProxy(settings.endpoint, settings.timeout);

    };


    /**
    * gets a label
    *
    * @param {string} name
    * @function
    */
    w.Confused.LookupServiceProxy.prototype.getLabel = function(path, options) {           

        var settings = $.extend({}, options, { method: "Label", data: { path: path } });

        var invoke = this.serviceProxy.invoke(settings);

        return invoke;

    };

}(window.jQuery, window));